import { autoinject, LogManager } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { SupportTicketService } from 'data/service/support-ticket-service';
import { SupportTicket } from 'data/entities/entities';

@autoinject
export class SupportHome {
	constructor(private supportTicketService: SupportTicketService, private router: Router) {		
	}

	openTickets: Array<SupportTicket>;
	closedTickets: Array<SupportTicket>;
	className = "Support Home";
	logger = LogManager.getLogger(this.className);

	async getClosedTickets() {
		this.closedTickets = await this.supportTicketService.getClosedTickets();
	}

	async activate() {
		await this.getOpenTickets();
		await this.getClosedTickets();
	}

	async getOpenTickets() {
		this.openTickets = await this.supportTicketService.getOpenTickets();
	}

	addTicket() {
		this.logger.info("creating new ticket");
		this.router.navigateToRoute('addTicket');
	}
}
	